import { defineComponent as _defineComponent } from 'vue'
import { inject, ref, Ref, watch } from 'vue';

import {
  NavBar,
  HeadingDisplay,
  Heading,
  BaseText,
  ContentDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';
import { PasswordModal } from '@/modules/trade/components/PasswordModal';

import { IMarginAllocationPreviewV2 } from '@/modules/trade/services/margin-allocation';

import { removeBodyScroll } from '@/modules/common/helpers/browser';

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}
interface Props {
  isOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Terms',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
  (event: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
};





const marginAllocationPreview = inject(
  'marginAllocationPreview'
) as Ref<IMarginAllocationPreviewV2>;

const dataForm = inject('dataForm') as Ref<{ isUpdatingLimits: boolean }>;

const isPasswordModalOpen = ref(false);

function goToTerms() {
  window.open(marginAllocationPreview.value.termsLink, '_blank');
}

function confirmPassword() {
  isPasswordModalOpen.value = false;
  emit('confirm');
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);

return { __sfc: true,emit, props, marginAllocationPreview, dataForm, isPasswordModalOpen, goToTerms, confirmPassword, NavBar, HeadingDisplay, Heading, BaseText, ContentDisplay, ButtonContainer, ButtonPrimary, SideSheet, BackButton, PasswordModal }
}

})